import { useRdOptions } from "./use-rd-options";

export type ViewedRd =
  /** The roster has not answered yet. */
  | { status: "loading"; name: null }
  /** The roster answered and names the selected RD. */
  | { status: "ready"; name: string }
  /** The roster answered and holds no RD with this id: a stale link. */
  | { status: "missing"; name: null }
  /** The roster request failed; the selection stands but cannot be named. */
  | { status: "error"; name: null };

/** The selected RD, resolved against the roster. Distinguishes "not yet" from
 *  "not there" so a stale link never leaves a placeholder on screen forever. */
export function useViewedRd(rdId: string | undefined): ViewedRd | null {
  const options = useRdOptions(rdId !== undefined);
  if (!rdId) return null;
  if (options.isError) return { status: "error", name: null };
  if (!options.data) return { status: "loading", name: null };
  const name = options.data.data.find((rd) => rd.id === rdId)?.name;
  return name === undefined ? { status: "missing", name: null } : { status: "ready", name };
}

/** The selected RD's display name, verbatim. Null until the roster resolves —
 *  an identity line must never be a placeholder. */
export function useViewedRdName(rdId: string | undefined): string | null {
  return useViewedRd(rdId)?.name ?? null;
}
